import { MilestoneStatusCode, UnitOfMeasure, PersonaType, CrewMemberShiftType } from '@bechtel/types';

export const CommodityMilestonesMocks: any = [
  {
    id: '77121e05-8afe-464f-8e5b-e1096d0bfb64',
    name: 'Weldout',
    hours: 22.03,
    plannedEndDate: '2020-08-16T04:00:00Z',
    plannedStartDate: '2020-08-10T04:00:00Z',
    weekNumber: 33,
    currentStatus: {
      id: '8259fb2a-69ca-4bb3-be88-cea7f951ef5b',
      codeI18n: MilestoneStatusCode.PLANNED,
      rejectionType: null,
      comments: null,
      createdAt: null,
      createdBy: null,
    },
    quantity: {
      quantity: 2.75,
      unitOfMeasure: UnitOfMeasure.LINEAR_FEET,
    },
    type: {
      id: '9f335d96-bdd7-4c51-8cf9-c8a8c3413d03',
      name: 'Weldout',
    },
    weldStatuses: [],
    commodity: {
      materialCommodity: {
        id: '824722c6-4aa0-4eae-9275-200328f22f72',
        tag: '6UUG003X-DAC597920-02-1',
        workPackage: {
          id: '235d0013-904f-43fc-9bfc-3b180c057f95',
          tag: '6UUG003X-P-000033',
          primaryOwners: [
            {
              persona: PersonaType.FOREMAN,
              crewMember: {
                id: '824aae0b-50f5-480b-93ec-a5db99f1d354',
                name: 'ERIC LARKINS',
                imageUrl: 'http://localhost:8081/avatar?etrackid=508322',
                shiftType: CrewMemberShiftType.DAY,
              },
            },
            {
              persona: PersonaType.GENERAL_FOREMAN,
              crewMember: {
                id: '929150d4-9e92-439c-9b52-3f67f6d74d71',
                name: 'JEFFREY HEELAN',
                imageUrl: 'http://localhost:8081/avatar?etrackid=503208',
                shiftType: CrewMemberShiftType.DAY,
              },
            },
            {
              persona: PersonaType.SUPERINTENDENT,
              crewMember: {
                id: 'ff8b69ab-e776-4ae9-9686-9aa23e0d7864',
                name: 'Craig Baldwin',
                imageUrl: 'http://localhost:8081/avatar?etrackid=510255',
                shiftType: CrewMemberShiftType.DAY,
              },
            },
            {
              persona: PersonaType.FIELD_ENGINEER,
              crewMember: {
                id: '1c8415a6-8117-4094-a766-8f9888160722',
                name: 'Joseph Bartell',
                imageUrl: 'http://localhost:8081/avatar?etrackid=502449',
                shiftType: CrewMemberShiftType.DAY,
              },
            },
          ],
          secondaryOwners: [],
          otherOwners: [],
        },
        type: {
          id: 'project-commodity-type-0-1',
          name: 'UG Spool',
        },
      },
      weld: null,
    },
  },
];
